import cx from 'classnames';
import React from 'react';

import { Button, ButtonProps } from '../../button/button';
import { SimpleText } from '../../simple-text/simple-text';

import './lesson-passport__button.scss';

interface Props extends ButtonProps {
    textId: string;
    mix?: string;
}

export const LessonPassportButton = React.memo(({ textId, mix, ...props }: Props) => {
    return (
        <Button className={cx('lesson-passport__button', mix)} {...props}>
            <SimpleText id={textId} />
        </Button>
    );
});
